import React from "react";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import uuid from 'react-uuid';
import './Tooltip.style.css'
const Tp = Tooltip;

function ToolTip({ children, message, placement }) {
  const renderTooltip = (props) => (
    <Tp id={uuid()} {...props}>
      <div style={{whiteSpace: 'pre-line', textAlign: 'left'}}>{message}</div>
    </Tp>
  );

  return (
    <OverlayTrigger
      placement={placement ? placement : "top"}
      overlay={renderTooltip() || function () {}}
      onToggle={() => {}}
      delay={{ show: 700 }}
    >
      {children}
    </OverlayTrigger>
  );
}
export default ToolTip;
